import React, { useEffect, useState } from "react";
import { format, parseISO } from "date-fns";
import { sortingFns } from "@tanstack/react-table";
import { compareItems } from "@tanstack/match-sorter-utils";
import MasterTable from "../../../components/master/MasterTable";
import { contractAddIcon, downloadIcon } from "../../../assetData/icons";
import { actionPerm } from "../../../components/authNavigation/AuthNavbar";
import { sortData } from "../../../utils/sortData";
import { FaSortDown, FaSortUp } from "react-icons/fa";
import { downloadLoader } from "../../../assetData/loaders";

const fuzzySort = (rowA, rowB, columnId) => {
  console.log("functioning... fuzzySort");
  let dir = 0;

  // Only sort by rank if the column has ranking information
  if (rowA.columnFiltersMeta[columnId]) {
    dir = compareItems(
      rowA.columnFiltersMeta[columnId]?.itemRank,
      rowB.columnFiltersMeta[columnId]?.itemRank,
    );
  }

  // Provide an alphanumeric fallback for when the item ranks are equal
  return dir === 0 ? sortingFns.alphanumeric(rowA, rowB, columnId) : dir;
};

const MasterDepositoryTable = (props) => {
  const {
    tableData,
    buttonConfig,
    setIsAdd,
    setIsEdit,
    setIsDelete,
    setSelectedItemId,
    renderKey,
    setGlobalFilters,
    loading,
    actionPermissions,
    isDownloadClicked,
  } = props;

  const [tableFilter, setTableFilter] = useState(tableData);
  const [sortingType, setSortingType] = useState("asc");
  const [sortColumn, setSortColumn] = useState("name");

  useEffect(() => {
    setTableFilter(tableData);
  }, [tableData]);

  const handleSorting = (column, sortType, type) => {
    setSortColumn(column);

    const sortedData = sortData({
      data: tableData,
      column,
      type,
      sortType,
    });

    setTableFilter(sortedData);
    setSortingType(sortingType === "asc" ? "desc" : "asc");
  };

  const columns = React.useMemo(
    () => [
      {
        accessorKey: "sl",
        header: () => <span>S. NO.</span>,
        cell: (info) => <span>{info.row.index + 1}.</span>,
      },

      // {
      //   accessorKey: "id",
      //   header: () => <span>ID</span>,
      //   cell: (info) => info.renderValue(),
      // },
      {
        accessorFn: (row) => row.id,
        id: "demat_id",
        cell: (info) => info.getValue(),
        header: () => (
          <div
            onClick={() => {
              handleSorting(
                "id",
                sortingType === "asc" ? "desc" : "asc",
                "number",
              );
            }}
            className="flex justify-between"
          >
            <div>DEMAT ID</div>
            <div className="space-y-[-10px]">
              <FaSortUp
                className={` ${
                  sortColumn === "id" && sortingType === "asc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
              <FaSortDown
                className={`${
                  sortColumn === "id" && sortingType === "desc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
            </div>
          </div>
        ),
        filterFn: "fuzzy",
        sortingFn: fuzzySort,
      },
      {
        accessorFn: (row) => row.name,
        id: "name",
        cell: (info) => info.getValue(),
        header: () => (
          <div
            onClick={() => {
              handleSorting(
                "name",
                sortingType === "asc" ? "desc" : "asc",
                "string",
              );
            }}
            className=" flex justify-between"
          >
            <div>Demat NAME</div>
            <div className="space-y-[-10px]">
              <FaSortUp
                className={` ${
                  sortColumn === "name" && sortingType === "asc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
              <FaSortDown
                className={`${
                  sortColumn === "name" && sortingType === "desc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
            </div>
          </div>
        ),
        filterFn: "fuzzy",
        sortingFn: fuzzySort,
      },

      {
        accessorFn: (row) => row.short_name,
        id: "short_name",
        header: () => (
          <div
            onClick={() => {
              handleSorting(
                "short_name",
                sortingType === "asc" ? "desc" : "asc",
                "string",
              );
            }}
            className=" flex justify-between"
          >
            <div>SHORT NAME</div>
            <div className="space-y-[-10px]">
              <FaSortUp
                className={` ${
                  sortColumn === "short_name" && sortingType === "asc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
              <FaSortDown
                className={`${
                  sortColumn === "short_name" && sortingType === "desc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
            </div>
          </div>
        ),
        header: () => <span> SHORT NAME</span>,
      },

      {
        accessorFn: (row) => row.dep_code,
        id: "dep_code",
        cell: (info) => info.getValue(),
        header: () => (
          <div
            onClick={() => {
              handleSorting(
                "dep_code",
                sortingType === "asc" ? "desc" : "asc",
                "string",
              );
            }}
            className=" flex justify-between"
          >
            <div>DEPOSITORY CODE</div>
            <div className="space-y-[-10px]">
              <FaSortUp
                className={` ${
                  sortColumn === "dep_code" && sortingType === "asc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
              <FaSortDown
                className={`${
                  sortColumn === "dep_code" && sortingType === "desc"
                    ? "opacity-100"
                    : "opacity-50"
                }`}
              />
            </div>
          </div>
        ),
      },
      {
        accessorKey: "status",
        header: () => <span>STATUS</span>,
        cell: (info) => (
          <span className="tracking-widest">{info.getValue()}</span>
        ),
      },

      {
        accessorKey: "id",
        header: () => <span>ACTION</span>,
        cell: (info) => <span> </span>,
      },
    ],
    [sortColumn, sortingType, tableData, tableFilter],
  );

  const handleDownloadButtonClick = () => {
    console.log("Download button clicked!"); // Add this line
    buttonConfig.downloadHandler();
  };

  const actionConfig = [
    {
      id: "1",
      name: "Add Demat",
      image: contractAddIcon,
      actionHandler: () => setIsAdd(true),
      disable: actionPerm(actionPermissions)?.add_perm,
    },

    {
      id: "2",
      name: "Download Data",
      image: isDownloadClicked ? downloadLoader : downloadIcon,
      actionHandler: isDownloadClicked
        ? () => {}
        : buttonConfig.downloadHandler,
      disable: actionPerm(actionPermissions)?.download_perm,
    },
  ];

  const action = actionPerm(actionPermissions);

  let name = "Add Demat";

  return (
    <MasterTable
      name={name}
      loading={loading}
      columns={columns}
      tableData={tableFilter?.length > 0 ? tableFilter : tableData}
      buttonConfig={buttonConfig}
      setIsAdd={setIsAdd}
      setIsEdit={setIsEdit}
      setIsDelete={setIsDelete}
      setSelectedItemId={setSelectedItemId}
      renderKey={renderKey}
      filterField
      actionConfig={actionConfig}
      setGlobalFilters={setGlobalFilters}
      handleDownloadButtonClick={handleDownloadButtonClick}
      actions={action}
    />
  );
};

export default MasterDepositoryTable;
